import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  getButtonId,
  getState,
  isDisabled
} from './loadingButton.helpers.js';

import LdsButton from '../LdsButton/index.jsx';
import LdsLoadingSpinner from '../LdsLoadingSpinner/index.jsx';

function LdsLoadingButton({
  children,
  buttonClasses = undefined,
  disabled = false,
  id,
  linkButton = false,
  loadingSpinnerSize = undefined,
  loadingSpinnerSpeed = undefined,
  onClick,
  state = 'ready',
  type = 'button',
  disableLoadingSpinner = false,
  className = undefined,
  classes = undefined,
  ...rest
}) {
  // Ensure state value is valid
  const validState = getState(state);

  // Define the loading spinner based on whether it should be used
  const LoadingButtonSpinner = () => {
    if (disableLoadingSpinner) return '';
    return (
      <LdsLoadingSpinner
        size={loadingSpinnerSize}
        animationSpeed={loadingSpinnerSpeed}
        decorative
      ></LdsLoadingSpinner>
    );
  };

  return (
    <div
      id={id}
      className={cn(
        'lds-loading-button',
        {
          loading: validState === 'loading',
          success: validState === 'success',
          failure: validState === 'failure',
          'no-spinner': disableLoadingSpinner,
        },
        className,
        classes
      )}
      aria-live="assertive"
      {...rest}
    >
      <LdsButton
        id={getButtonId(id)}
        classes={cn(
          {
            'sr-only': validState === 'loading' && !disableLoadingSpinner,
            'loading-success': validState === 'success',
            'loading-failure': validState === 'failure',
            [`${buttonClasses}`]: buttonClasses,
          }
        )}
        disabled={isDisabled(validState, disabled)}
        linkButton={linkButton}
        onClick={onClick}
        type={type}
      >
        {children}
      </LdsButton>
      <LoadingButtonSpinner></LoadingButtonSpinner>
    </div>
  );
}

function LabelDefault({ children = 'BUTTON LABEL', ...rest }) {
  return (
    <span className="lds-loading-btn-text-default" {...rest}>
      {children}
    </span>
  );
}
LdsLoadingButton.LabelDefault = LabelDefault;

function LabelLoading({ children = 'LOADING LABEL', ...rest }) {
  return (
    <span className="lds-loading-btn-text-loading" {...rest}>
      {children}
    </span>
  );
}
LdsLoadingButton.LabelLoading = LabelLoading;

function LabelSuccess({ children = 'SUCCESS LABEL', ...rest }) {
  return (
    <span className="lds-loading-btn-text-success" {...rest}>
      {children}
    </span>
  );
}
LdsLoadingButton.LabelSuccess = LabelSuccess;

function LabelFailure({ children = 'FAILURE LABEL', ...rest }) {
  return (
    <span className="lds-loading-btn-text-failure" {...rest}>
      {children}
    </span>
  );
}
LdsLoadingButton.LabelFailure = LabelFailure;

export default LdsLoadingButton;

LdsLoadingButton.propTypes = {
  id: PropTypes.string,
  buttonClasses: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  linkButton: PropTypes.bool,
  loadingSpinnerSize: PropTypes.number,
  loadingSpinnerSpeed: PropTypes.number,
  state: PropTypes.oneOf(['loading', 'success', 'failure', 'ready']),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};
